<template>
    <div class="main">
        <div class="div_logo">
            <van-image width="70%" :src="require('../../assets/transport/title.svg')" style="top: 10px;"/>
            <p style="color: #6C5141;">——内部收发货平台——</p>
        </div>
        <div class="div_flex" style="margin: -40px 12px 0 12px;height: 40px;">
            <a>我的订单</a>
            <van-button round type="info" size="small" @click="GotoListPage">查看订单</van-button>
        </div>
        <div class="div_card">
            <div style="padding-left: 12px;font-size: 14px;"><van-icon name="youzan-shield" color="#999999"/>3小时内高效转运服务</div>
            <div class="div_flex">
                <div class="div_input" @click="onAddress('发货')">
                    <a class="div_icon" style="background-color: #333333;">发</a>
                    <div class="div_address" :style="{ color: form.DeliveryAddress === '选择发货地点' ? '#999999' : 'black' }">{{ form.DeliveryAddress }}</div>
                    <van-icon name="arrow" v-if="form.DeliveryAddress === '选择发货地点'"/>
                </div>
                <div style="border-left: 1px solid #9999;height: 25%;"></div>
                <div style="text-align: center;">
                    <div style="font-weight: 600;">{{ form.Name}}<a style="font-size: 14px;padding-left: 4px;">{{ form.Department }}</a></div>
                    <!-- <div style="font-size: 14px;">{{ form.Phone }}</div> -->
                    <div style="font-size: 14px;">{{ form.Landline }}</div>
                </div>
            </div>
            <div class="div_flex">
                <div class="div_input" @click="onAddress('收货')">
                    <a class="div_icon" style="background-color: #FEB013;">收</a>
                    <div class="div_address" :style="{ color: form.ShipAddress === '选择收货地点' ? '#999999' : 'black' }">{{ form.ShipAddress }}</div>
                    <van-icon name="arrow" v-if="form.ShipAddress === '选择收货地点'"/>
                </div>
                <div style="border-left: 1px solid #9999;height: 25%;"></div>
                <div @click="showPerson = true" style="text-align: center;">
                    <div v-if="form.Receiver">
                        <div style="font-weight: 600;">{{ form.Receiver}}<a style="font-size: 14px;padding-left: 4px;">{{ form.ReceiverDepartment }}</a></div>
                        <div style="font-size: 14px;">{{ form.ReceiverLandline }}</div>
                    </div>
                    <div v-else class="div_txl">选择收货人<a style="font-size: 12px;">通讯录</a></div>
                </div>
            </div>
            <van-cell title="送货时间" is-link :value="form.DeliveryTime" @click="showTimePicker = true"/>
            <div style="padding: 10px 12px 0 12px;font-size: 14px;"><van-icon name="checked" />送货时间段为上午12点前或下午4点半前</div>
        </div>
        <div class="div_card">
            <a class="div_input" style="padding: 0 12px;color: #000;">货物名称<a class="div_icon icon_checked">必填</a></a>
            <van-radio-group v-model="form.ItemName" direction="horizontal" class="div_radio">
                <van-radio name="产品">产品</van-radio>
                <van-radio name="空桶">空桶</van-radio>
                <van-radio name="包材">包材</van-radio>
                <van-radio name="其他">其他</van-radio>
            </van-radio-group>
            <van-field v-if="form.ItemName === '其他'" v-model="form.ItemOtherName" label="其他" placeholder="请输入货物名称" input-align="right"/>
            <van-field readonly clickable label="数量" :value="form.ItemNum + ' ' + form.ItemUnit" @click="showUnit = true" input-align="right"/>
            <van-field v-model="form.Remark" label="备注" placeholder="请输入备注信息" input-align="right" rows="1" autosize type="textarea" maxlength="100" show-word-limit/>
            <van-popup v-model="showUnit" show-toolbar round position="bottom">
                <van-picker show-toolbar :columns="unitColumns" @cancel="showUnit = false" @confirm="onUnit" />
            </van-popup>
        </div>
        <div style="margin: 12px;">
            <van-button block round :disabled="btnStatus" color="#FEB013" @click="onSubmit">去下单</van-button>
        </div>
        <van-popup v-model="showAddress" round position="bottom" :close-on-click-overlay="false">
        <!-- <van-popup v-model="showAddress" round position="bottom" :close-on-click-overlay="false" closeable close-icon="close" :style="{ height: addressHeight }"> -->
            <!-- <div style="margin: 15px 12px;font-weight: 600;">选择收货地址</div>
            <div style="padding: 0 12px 10px 12px;font-size: 14px;color: #999;">发收货地点仅限以下3条</div>
            <div class="flex_select" @click="selectAddress('健帆园区北')">
                <van-image width="8%" :src="require('../../assets/transport/arrow.svg')" style="top: 2px;"/>
                <p style="font-weight: 600;">健帆园区北</p>
            </div>
            <div class="flex_select" @click="selectAddress('健帆园区南')">
                <van-image width="8%" :src="require('../../assets/transport/arrow.svg')" style="top: 2px;"/>
                <p style="font-weight: 600;">健帆园区南</p>
            </div>
            <div class="flex_select" @click="selectAddress('金鼎园区')">
                <van-image width="8%" :src="require('../../assets/transport/arrow.svg')" style="top: 2px;"/>
                <p style="font-weight: 600;">金鼎园区</p>
            </div> -->
            <van-picker show-toolbar :title="addressTitle" :columns="addressColumns" @cancel="showAddress = false" @confirm="onConfirmAddress"/>
        </van-popup>
        <van-popup v-model="showTimePicker" position="bottom" round :close-on-click-overlay="false">
            <van-picker show-toolbar title="选择送货时间" :columns="timeColumns" @cancel="showTimePicker = false" @confirm="onConfirmTime"/>
        </van-popup>
        <van-popup v-model="showPerson" position="right" style="height:100%;" closeable close-icon="close" close-icon-position="bottom-left">
            <div style="display: flex;">
                <van-sidebar v-model="activeKey" style="min-width: 100px;" @change="onDepartment">
                    <van-sidebar-item title="仓储物流部" />
                    <van-sidebar-item title="制造一部" />
                    <van-sidebar-item title="制造二部" />
                    <van-sidebar-item title="医疗设备" />
                    <van-sidebar-item title="生产管理部" />
                    <van-sidebar-item title="设备部" />
                    <van-sidebar-item title="健力" />
                    <van-sidebar-item title="血液净化" />
                    <van-sidebar-item title="质量检测部" />
                    <van-sidebar-item title="精益技术部" />
                    <van-sidebar-item title="材料与柱体研究部" />
                    <van-sidebar-item title="重症产品研发部" />
                    <van-sidebar-item title="临床部" />
                </van-sidebar>
                <div style="width: 250px;">
                    <van-search v-model="selectValue" show-action placeholder="请输入搜索关键词" @search="SelectPerson" @clear="onDepartment(activeKey)">
                        <template #action>
                            <div @click="SelectPerson">搜索</div>
                        </template>
                    </van-search>
                    <div style="overflow: auto;" :style="{ height: personHeight + 'px' }">
                        <van-loading vertical v-if="personBtn" style="top: 30%;">加载中...</van-loading>
                        <div v-for="(item, key) in personlist" :key="key" class="card_person">
                            <van-radio-group v-model="form.ReceiverId" @change="onPerson" class="div_flex_radio">
                                <div><van-icon name="friends" />{{ item.name }}</div>
                                <div>{{ item.mobile }}</div>
                                <van-radio :name="item.userid" />
                            </van-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            DriverList: [], // ['余建光','吕新强','张伟建','卢卫星','蔡志恒','谢志强','曾简斌'],
            form: {
                Name: '',      // 姓名
                UserId: '',    // 工号
                Department: '', // 部门
                Phone: '',     // 手机号
                Landline: '',  // 座机
                ItemName: '',  // 货物名称
                ItemNum: 0,     // 货物数量
                ItemUnit: '', // 货物单位
                DeliveryAddress: '选择发货地点',    // 发货地点
                ShipAddress: '选择收货地点',    // 收货地点
                DeliveryTime: '选择时间段',     // 送货时间
                Receiver: '',  // 收货人
                ReceiverId: '', // 收货人工号
                ReceiverDepartment: '', // 收货人部门
                ReceiverPhone: '', // 收货人手机号
                ReceiverLandline: '', // 收货人座机
                Status: '待接单', // 订单状态
                Remark: '' // 备注
            },
            addressTitle: '',
            showAddress: false,
            addressHeight: window.innerHeight > 677 ? '35%' : '45%',
            addressColumns: [
                {
                    text: '健帆园南区',
                    disabled: false,
                    children: [
                        {text:'研发楼东边'},
                        {text:'车间转货平台'},
                        {text:'仓储物流仓库门口'},
                        {text:'化学仓库门口'}
                    ]
                },
                {
                    text: '健帆园北区',
                    disabled: false,
                    children: [
                        {text:'卸货平台'}
                    ]
                },
                {
                    text: '金鼎园区',
                    disabled: false,
                    children: [
                        {text:'仓储物流仓库卸货平台'},
                        {text:'灌流器总厂卸货平台'},
                        {text:'化学仓库门口'}
                    ]
                }
            ],
            showTimePicker: false,
            timeColumns: [
                {
                    text: '',
                    disabled: false,
                    children: [
                        {text:'09:00', disabled: false},
                        {text:'09:30', disabled: false},
                        {text:'10:00', disabled: false},
                        {text:'10:30', disabled: false},
                        {text:'11:00', disabled: false},
                        {text:'11:30', disabled: false},
                        {text:'12:00', disabled: false},
                        {text:'13:30', disabled: false},
                        {text:'14:00', disabled: false},
                        {text:'14:30', disabled: false},
                        {text:'15:00', disabled: false},
                        {text:'15:30', disabled: false},
                        {text:'16:00', disabled: false}
                    ]
                },
                {
                    text: '',
                    children: [
                        {text:'09:00', disabled: false},
                        {text:'09:30', disabled: false},
                        {text:'10:00', disabled: false},
                        {text:'10:30', disabled: false},
                        {text:'11:00', disabled: false},
                        {text:'11:30', disabled: false},
                        {text:'12:00', disabled: false},
                        {text:'13:30', disabled: false},
                        {text:'14:00', disabled: false},
                        {text:'14:30', disabled: false},
                        {text:'15:00', disabled: false},
                        {text:'15:30', disabled: false},
                        {text:'16:00', disabled: false}
                    ]
                }
            ],
            showPerson: false,
            activeKey: 0,
            personBtn: false,
            personlist: [],
            personHeight: window.innerHeight - 55,
            btnStatus: false,
            tmpPerson: '',
            selectValue: '',
            showUnit: false,
            unitColumns: [
                {
                    values: []
                },
                {
                    values: ['板', '个', '桶', '箱', '车']
                }
            ]
        }
    },
    async created() {
        // const test = {"errno":0,"data":{"errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
        // this.WXInfo = test.data
        this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
        // 拼装日期和星期
        let zw = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
        this.timeColumns[0].text = [ this.$moment().format('MM.DD') + ' '  + zw[this.$moment().day()] ]
        this.timeColumns[1].text = [ this.$moment().add(1, 'days').format('MM.DD') + ' '  + zw[this.$moment().add(1, 'days').day()] ]

        if (this.$moment().format('HH:mm') > '08:40' && this.$moment().format('HH:mm') <= '12:00') {
            this.timeColumns[0].children.forEach(item => {
                if (item.text <= '12:00') {
                    item.disabled = true
                }
            })
        } else if (this.$moment().format('HH:mm') > '12:00') {
            this.timeColumns[0].disabled = true
        }
        for(let i=1; i<=100; i++) {
            this.unitColumns[0].values.push(i)
        }
        // for(let i=0; i<2; i++) {
        //     const date = this.$moment().add(i, 'days').format('MM.DD') + ' '  + zw[this.$moment().add(i, 'days').day()]
        //     this.timeColumns[0].values.push(date)
        // }
    },
    mounted() {
        this.form.Name = this.WXInfo.name
        this.form.UserId = this.WXInfo.userid
        this.form.Phone = this.WXInfo.mobile
        if (this.WXInfo.name === '王海苑') {
            this.$router.push('/transport/driver')
        }
        this.init()
    },
    methods: {
        async init() {
            // 获取车队人员列表
            let userlist = await this.getQWUserList(3209)
            userlist.forEach(item => {
                if (item.name === this.form.Name) {
                    this.$router.push('/transport/driver')
                } else {
                    let data = {
                        name: item.name,
                        userid: item.userid
                    }
                    this.DriverList.push(data)
                }
            })
            let res = await this.getUserInfo(this.form.UserId)
            this.form.Department = res.departmentname
            this.form.Landline = res.telephone
            this.personlist = await this.getQWUserList(2583)
        },
        SelectPerson () {
            this.personlist = this.personlist.filter(item => {
                return item.name.indexOf(this.selectValue) !== -1
            })
        },
        sendMessage(id) {
            let driverMessage = '转货任务通知：' +
                '\n\n送货时间：' + this.form.DeliveryTime +
                '\n发货人：' + this.form.Name +
                '\n收货人：' + this.form.Receiver +
                '\n货物：' + this.form.ItemName +
                '\n数量：' + this.form.ItemNum + this.form.ItemUnit +
                '\n发货地点：' + this.form.DeliveryAddress +
                '\n收货地点：' + this.form.ShipAddress +
                '\n\n您收到一个转货任务，请及时处理。\n\n' +
                '<a href="https://pinche.jafron.com/transport/detail?role=driver&id='+ id +'">查看详情</a>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;' +
                '<a href="https://pinche.jafron.com/transport/index">转货列表</a>'
            // this.postSendMessage('2017551', driverMessage)
            this.DriverList.forEach(item => {
                this.postSendMessage(item.userid, driverMessage)
            })
        },
        GotoListPage() {
            this.$router.push('/transport/list?role=sponsor')
        },
        onAddress(type) {
            this.addressType = type
            this.addressTitle = '选择' + type + '地点'
            this.showAddress = true
        },
        onConfirmTime(value) {
            this.form.DeliveryTime = value[0] + ' ' + value[1]
            this.showTimePicker = false
            console.log(this.form.DeliveryTime)
        },
        onConfirmAddress(value) {
            if (this.addressType === '发货') {
                this.form.DeliveryAddress = value[0] + ' ' + value[1]
            } else {
                this.form.ShipAddress = value[0] + ' ' + value[1]
            }
            this.showAddress = false
        },
        onUnit(value) {
            console.log(value)
            this.form.ItemNum = value[0]
            this.form.ItemUnit = value[1]
            this.showUnit = false
        },
        async onDepartment (value) {
            this.personBtn = true
            this.selectValue = ''
            this.personlist = []
            switch (value) {
                case 0:
                    // 仓储物流部
                    this.personlist = await this.getQWUserList(2583)
                    break
                case 1:
                    // 制造一部
                    this.personlist = await this.getQWUserList(676)
                    break
                case 2:
                    // 制造二部
                    this.personlist = await this.getQWUserList(2509)
                    break
                case 3: {
                    // 医疗设备（设备车间、管路车间）
                    const alist = await this.getQWUserList(3545)
                    const blist = await this.getQWUserList(3547)
                    this.personlist = alist.concat(blist)
                    break
                }
                case 4:
                    // 生产管理部
                    this.personlist = await this.getQWUserList(1560)
                    break
                case 5:
                    // 设备部
                    this.personlist = await this.getQWUserList(3287)
                    break
                case 6:
                    // 健力
                    this.personlist = await this.getQWUserList(3284)
                    break
                case 7: {
                    // 建航
                    const alist = await this.getQWUserList(2503)
                    const blist = await this.getQWUserList(3031)
                    const clist = await this.getQWUserList(3402)
                    this.personlist = alist.concat(blist, clist)
                    break
                }
                case 8:
                    // 质量检测部
                    this.personlist = await this.getQWUserList(2517)
                    break
                case 9:
                    // 精益技术部
                    this.personlist = await this.getQWUserList(3638)
                    break
                case 10:
                    // 材料与柱体研究部
                    this.personlist = await this.getQWUserList(3296)
                    break
                case 11:
                    // 重症产品研发部
                    this.personlist = await this.getQWUserList(3294)
                    break
                case 12:
                    // 临床部
                    this.personlist = await this.getQWUserList(2239)
                    break
                default:
                    break
            }
            this.personBtn = false
        },
        async onPerson (value) {
            if (this.tmpPerson !== value) {
                this.tmpPerson = value // 阻制change多次触发
                this.form.Receiver = this.personlist.find(item => item.userid === value).name
                this.form.ReceiverPhone = this.personlist.find(item => item.userid === value).mobile
                this.form.ReceiverId = value
                let data = await this.getUserInfo(value)
                this.form.ReceiverDepartment = data.departmentname
                this.form.ReceiverLandline = data.telephone
                this.showPerson = false
            }
        },
        async getUserInfo(data) {
            const result = await this.$request({
                url: '/api/tokenOA/getOAUserInfo',
                method: 'GET',
                params: {
                    UserId: data
                }
            })
            if (result.success) {
                return result.data[0]
            } else {
                this.$toast(result.message)
            }
        },
        async getQWUserList(id) {
            const result = await this.$request({
                url: '/api/WXAuthorize/getDepartmentUserbyQW',
                method: 'GET',
                params: { id: id }
            })
            if (result.success) {
                return result.data
            } else {
                this.$toast(result.message)
            }
        },
        async onSubmit() {
            console.log('onSubmit', this.form)
            if (!this.form.DeliveryAddress === '选择发货地点' || !this.form.ShipAddress === '选择收货地点' || !this.form.DeliveryTime === '选择时间段' || !this.form.ItemName || !this.form.ItemNum || !this.form.ReceiverId) {
                this.$toast('请填写完整信息')
                return
            }
            this.form.ItemName = this.form.ItemName === '其他' ? this.form.ItemOtherName : this.form.ItemName
            this.btnStatus = true
            const result = await this.$request({
                url: '/api/GeneralMethod/postFunctionSave',
                method: 'POST',
                params: { Name: 'transport' },
                data: this.form
            })
            if (result.success) {
                this.$toast('提交成功')
                this.sendMessage(result.data._id)
                this.$router.push('/transport/detail?id='+result.data._id+'&role=sponsor')
            } else {
                this.$toast(result.message)
                this.btnStatus = false
            }
        },
        async postSendMessage(userid, message) {
            const result = await this.$request({
                url: this.$api.postSendMessageWX,
                method: 'POST',
                data: {
                    'touser': userid,
                    'msgtype': 'text',
                    'agentid': this.$agentid,
                    'text': { 'content': message }
                }
            })
            if (!result.success) {
                this.$toast(result.message)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.main {
    height: inherit;
}
.div_logo {
    background: #FEB013;
    background-image: url('../../assets/transport/person.svg');
    background-repeat: no-repeat;
    background-position: right;
    background-size: 120px;
    color: white;
    text-align: left;
    box-shadow: 0px 3px 12px 0px rgba(252, 113, 39, 0.30);
    padding: 12px;
    font-size: 14px;
    height: 100px;
}
.div_flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 12px;
    margin: 5px 0;
    height: 50px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #F5F5F5;
    border-radius: 10px;
}
.div_card {
    background-color: #FFFFFF;
    border-radius: 10px;
    padding: 12px 0;
    margin: 10px 12px;
    color: #6C5141;
}
.div_input {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #999999;
    width: 50%;
}
.div_icon {
    font-size: 14px;
    font-weight: normal;
    color: #FFFFFF;
    border-radius: 50%;
    min-width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
}
.div_radio {
    padding: 20px 12px;
    justify-content: center;
    border-bottom: 1px solid #F5F5F5;
    margin: 0 10px;
}
.icon_checked {
    color: red;
    background-color: #F5F5F5;
    width: 40px;
    font-size: 12px;
    border-radius: 10px;
    margin-left: 8px;
}
.flex_select {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #FEB013;
    margin: 10px 12px;

}
.flex_select:active{
    background-color: #ebedf0;
}
.div_txl{
    min-width: 140px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.div_flex_radio {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.card_person {
    min-width: 200px;
    background-color: #f7f8fa;
    border-radius: 4px;
    margin: 10px 12px;
    padding: 10px 12px;
    color: #6C5141;
    font-size: 14px;
}
.div_address {
    white-space: pre-wrap;
    word-break: keep-all;
    text-align: center;
    font-size: 13px;
}

/deep/ .van-sidebar-item {
    padding: 12px;
}
</style>
  